import type { SelectProps } from '@mantine/core';
import { FormSelect } from '@shared/ui';

type CandidateActivitySelectProps = Pick<SelectProps, 'onChange' | 'value'>;

const ACTIVITY_OPTIONS = [
  { value: 'true', label: 'Активно' },
  { value: 'false', label: 'Неактивно' },
];

export const CandidateActivitySelect = ({
  value,
  onChange,
}: CandidateActivitySelectProps) => (
  <FormSelect
    variant='column'
    title='Активность'
    description=''
    aria-label='Активность'
    placeholder='Все'
    clearable
    data={ACTIVITY_OPTIONS}
    value={value}
    onChange={onChange}
    containerProps={{ gap: 4, flex: 1 }}
  />
);
